import { Component, OnInit } from '@angular/core';
import { Response } from '@angular/http';

import { Observable } from 'rxjs/Observable';

import { CBMError, Contract, CoordinateSystem } from 'app/models';
import { ContractType, FileType } from 'app/models/enums';
import {
  ContractService,
  CsvService,
  DownloadService,
  GeojsonService,
  HttpService,
  ShapefileService,
  ValidationService,
  VildVersionService
} from 'app/services';
import { DownloadExportTaskBase } from 'app/shared/export/downloadExportTaskBase';

interface CBMContractOption {
  id: number;
  prefix: string;
  name: string;
  checked: boolean;
}

@Component({
  selector: 'app-export-configurations',
  templateUrl: './export-configurations.component.html',
  styleUrls: ['./export-configurations.component.scss']
})
export class ExportConfigurationsComponent extends DownloadExportTaskBase implements OnInit {
  public optionsDataprovider: CBMContractOption[];
  public optionsFcd: CBMContractOption[];
  public enableDownloadVildChanges = false;

  constructor(
    private readonly contractService: ContractService,
    private readonly shapefileService: ShapefileService,
    private readonly csvService: CsvService,
    private readonly geojsonService: GeojsonService,
    private readonly validationService: ValidationService,
    private readonly vildVersionService: VildVersionService,
    httpService: HttpService,
    downloadService: DownloadService
  ) {
    super(httpService, downloadService);
  }

  ngOnInit() {
    this.contractService.getContracts().subscribe(
      contracts => this.setContractOptions(contracts || []),
      (errors: CBMError[]) => {
        this.errorMessages = errors;
      }
    );

    this.vildVersionService.hasFutureVildVersion().subscribe(
      hasFutureVildVersion => {
        this.enableDownloadVildChanges = hasFutureVildVersion;
      },
      (errors: CBMError[]) => {
        this.errorMessages = errors;
      }
    );
  }

  private setContractOptions(contracts: Contract[]): void {
    this.optionsDataprovider = [];
    this.optionsFcd = [];

    contracts.forEach(contract => {
      if (contract.contractType === ContractType.DataProvider) {
        this.optionsDataprovider.push({
          id: contract.id,
          prefix: contract.prefix,
          name: contract.name,
          checked: false
        });
      } else {
        this.optionsFcd.push({ id: contract.id, prefix: contract.prefix, name: contract.name, checked: false });
      }
    });
  }

  public selectAllDataproviderContracts(): void {
    this.optionsDataprovider.forEach(option => {
      option.checked = true;
    });
  }

  public deselectAllDataproviderContracts(): void {
    this.optionsDataprovider.forEach(option => {
      option.checked = false;
    });
  }

  public selectAllFcdContracts(): void {
    this.optionsFcd.forEach(option => {
      option.checked = true;
    });
  }

  public deselectAllFcdContracts(): void {
    this.optionsFcd.forEach(option => {
      option.checked = false;
    });
  }

  private getSelectedContractIds(): number[] {
    const checkedDataproviderContractIds = this.optionsDataprovider.filter(o => o.checked).map(o => o.id);
    const checkedFcdContractIds = this.optionsFcd.filter(o => o.checked).map(o => o.id);

    return checkedDataproviderContractIds.concat(checkedFcdContractIds);
  }

  public downloadFile(fileType: FileType): void {
    this.setDownloading(true);
    this.errorMessages = [];
    const checkedContractIds = this.getSelectedContractIds();
    let downloadFile: Observable<Response>;

    switch (fileType) {
      case FileType.csv:
        downloadFile = this.csvService.downloadCsvContracts(checkedContractIds);
        this.handleTaskAsync(downloadFile);
        break;
      case FileType.geojsonlinear:
        downloadFile = this.geojsonService.downloadGeojsonContracts(checkedContractIds, 'linear');
        this.handleTaskAsync(downloadFile);
        break;
      case FileType.geojsonpoint:
        downloadFile = this.geojsonService.downloadGeojsonContracts(checkedContractIds, 'point');
        this.handleTaskAsync(downloadFile);
        break;
      case FileType.validations:
        downloadFile = this.validationService.downloadValidations(checkedContractIds);
        this.handleTaskAsync(downloadFile);
        break;
    }
  }

  public downloadShapefile(coordinateSystem: CoordinateSystem): void {
    this.setDownloading(true);
    this.errorMessages = [];
    const checkedContractIds = this.getSelectedContractIds();
    let downloadFile: Observable<Response>;

    downloadFile = this.shapefileService.downloadShapefile(checkedContractIds, coordinateSystem);
    this.handleTaskAsync(downloadFile);
  }
}



// WEBPACK FOOTER //
// ./src/app/admin/export/configurations/export-configurations.component.ts